import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { TranslateLoader, TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APP_CONFIG, BaseAppConfig } from './app.config';

import { SocketIoModule, SocketIoConfig, Socket } from 'ngx-socket-io';
import { GlobalProvider } from '../providers/global';
import { ApiClient } from "../providers/api-client.service";
import { IonicStorageModule } from '@ionic/storage-angular';
import { ConfigService  } from '../services/config.service';
import { IvyRouteReuseStrategy } from './router/ivy-route-reuse.strategy';


export function initializeApp(configService: ConfigService) {
  return () => configService.loadConfig();
}
  
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

let socketConfig: SocketIoConfig = { 
  url: '', // Default empty (will be set dynamically)
  options: { autoConnect: false, transports: ['websocket'], upgrade: false } 
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    TranslateModule,
	IonicStorageModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: APP_CONFIG, useValue: BaseAppConfig },
    { provide: RouteReuseStrategy, useClass: IvyRouteReuseStrategy },
    ApiClient,
	GlobalProvider,
	ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true
    },
   { 
      provide: Socket,
      useFactory: (configService: ConfigService) => configService.createSocket(),
      deps: [ConfigService],
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule {}


